/* src/app/admin-dashboard/site-system/inventory/links/links.component.css */
mat-grid-tile {
  background: lightblue;
}
.col {
  margin: 2px;
  height: 100px;
  color: grey;
  cursor: pointer;
}
.col:hover {
  color: black;
  height: 99px;
  border: 2px solid #563d7c;
  border-radius: 5px;
}
.mat-mdc-tooltip {
  color: yellow !important;
}
a {
  margin: 5px;
  color: black;
}
.active {
  background: #8468ac;
}
.header h4 p {
  position: relative;
  top: 18px;
  left: 10px;
}
.belowThreashold {
  background: #FF9494;
}
.framentLoaded {
  background: white;
  animation: color-me-in 5s;
}
@keyframes color-me-in {
  0% {
    background: var(--custom-color);
  }
  100% {
    background: white;
  }
}
/*# sourceMappingURL=links.component.css.map */
